import { ENTRY_FORM_INPUT_CODE } from "./entryForm";

export const BANK_INFO_FORM_FIELDS = {
  BANK_NAME: "bankName",
  BANK_ACCOUNT_NAME: "bankAccountName",
  BANK_ACCOUNT_NO: "bankAccountNo",
  BANK_BRANCH_NAME: "bankBranchName",
};

export const INSURED_PERSON_FORM_FIELDS = {
  TITLE_NAME: "title",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  GENDER: "gender",
  NATIONALITY: "nationality",
  IDENTITY_NO: "identityNo",
  DOB: "dob",
  MARITAL_STATUS: "maritalStatus",
  OCCUPATION: "occupation",
  EMAIL: "email",
  MOBILE_NO: "mobileNo",
  WEIGHT_KG: "weight",
  HEIGHT_CM: "height",
  RELATION: "relation",
  OTP_VERIFIED_DATE: "otpVerifiedDate",
  OTP_REFERENCE_CODE: "otpReferenceCode",
};

export const BENEFICIARY_FORM_FIELDS = {
  SAME_AS_PARENT: "sameAsParent",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  NATIONALITY: "nationality",
  IDENTITY_NO: "identityNo",
  RELATION: "relation",
  BENEFIT: "benefitPercentage",
};

export const DELIVERY_POLICY_FORM_FIELDS = {
  POLICY_OPTION_CODE: "policyOptionCode",
  OPTION_EMAIL: "optionEmail",
  OPTION_INSURED_POSTMAIL: "optionInsurePostmail",
  OPTION_OTHER_POSTMAIL: "optionOtherPostmail",
};

export const TAX_DEDUCTION_FORM_FIELDS = {
  IS_REQUIRED_TAX_DEDUCTION: "isRequiredTaxDeduction",
  IS_SAME_AS_INSURED: "isSameAsInsured",
  TAX_ID: "taxId",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
};

export const BENEFICIARY_FORM_DEFAULT_VALUE = {
  NATIONALITY: "THAI",
  IDENTITY_NO_TYPE: "cid",
};

export const INSURED_PERSON_FORM_DEFAULT_VALUE = {
  NATIONALITY: "THAI",
  IDENTITY_NO_TYPE: "cid",
};

export const NATIONALITY = {
  THAI: "THAI",
  OTHER: "OTHER",
};

export const IDENTITY_NO_TYPE = {
  CID: "cid",
  PASSPORT_NO: "passportNo",
};

export const MAP_ENTRY_INPUT_TO_APPLICATION_SECTION = {
  [ENTRY_FORM_INPUT_CODE.INSURED_DATE_OF_BIRTH]: [
    "basic-insured-person",
    "child-insured-person",
    "main-driver-basic-info",
  ],
  [ENTRY_FORM_INPUT_CODE.INSURED_GENDER]: [
    "basic-insured-person",
    "child-insured-person",
    "main-driver-basic-info",
  ],
  [ENTRY_FORM_INPUT_CODE.INSURED_MARITAL_STATUS]: ["main-driver-basic-info"],
};

export const MAP_ENTRY_INPUT_TO_APPLICATION_INPUT = {
  [ENTRY_FORM_INPUT_CODE.INSURED_DATE_OF_BIRTH]: "dob",
  [ENTRY_FORM_INPUT_CODE.INSURED_GENDER]: "gender",
  [ENTRY_FORM_INPUT_CODE.INSURED_MARITAL_STATUS]: "maritalStatus",
};

export const INSURED_PERSON_TYPE = {
  BASIC_INSURED_PERSON: "basic-insured-person",
  PARENT_INSURED_PERSON: "parent-insured-person",
  CHILD_INSURED_PERSON: "child-insured-person",
};
